import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthModule } from './modules/auth/auth.module';
import { CanLoadAdmin } from './modules/auth/guards/can-load-admin.guard';
import { CanLoadCommon } from './modules/auth/guards/can-load-common.guard';
import { HomeComponent } from './modules/home/components/home/home.component';

const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    {
        path: 'admin',
        loadChildren: (): Promise<unknown> => import('../app/modules/admin-functions/admin-functions.module').then(m => m.AdminFunctionsModule),
        canLoad: [CanLoadAdmin]
    },
    {
        path: 'common',
        loadChildren: (): Promise<unknown> => import('../app/modules/common-requests/common-requests.module').then(m => m.CommonRequestsModule),
        canLoad: [CanLoadCommon]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
        AuthModule
    ],
    exports: [RouterModule],
    providers: [
        CanLoadAdmin,
        CanLoadCommon
    ]
})
export class AppRoutingModule {}
